/**
 * Configure canonical API client with the app's axios instance.
 * This ensures all generated functions use the same interceptors/baseURL.
 * Import this once at app startup (e.g. in src/index.js).
 */
import { configureApiClient } from '@pki-pwa/api-client';
import axiosInstance from './axios';

configureApiClient(axiosInstance);

export { configureApiClient };
